export default __webpack_public_path__ + "static/media/texas-flag.52dd9265.svg";